import {
    dispatch
} from '@rematch/core';
import {
    accountUsersService,
    subOrganizationService,
    initiativesService,
    organizationService,
    removeUserFromOrgService,
    deleteUserFromOrgService,
    usersPermissionsService,
    removeUserTeamsService
} from '../../services/feathers.service';
import {
    toastr
} from 'react-redux-toastr';

const initialState = {
    usersList: [],
    userError: null,
    userObj: null,
    orgUniqueId: null,
    executiveList: [],
    managerList: [],
    memberList: [],
    userTabName: '',
    isUserDelModalOpen: false,
    isUserDeactivateModal: false,
    userToDel: {},
    imageProfileObjectCloudinary: {},
    userTabTreeRef: null,
    loaderBar: false,
    curIndexPath: null,
    searchUserQuery: {},
    searchedUsers: [],
    deactUserData: {},
    newUserDetails:null,
    usersWithPermission: [],
    userTreeSelectedPathValue: null
};

export default {
    state: initialState,
    reducers: {
        setUsersList(state, payload) {
            return {
                ...state,
                usersList: payload
            }
        },
        setExecutiveList(state, payload) {
            return {
                ...state,
                executiveList: payload
            }
        },
        setManagerList(state, payload) {
            return {
                ...state,
                managerList: payload
            }
        },
        setMemberList(state, payload) {
            return {
                ...state,
                memberList: payload
            }
        },
        setError(state, payload) {
            return {
                ...state,
                invitationError: payload
            }
        },
        storeUser(state, payload) {
            return {
                ...state,
                userObj: payload
            }
        },
        updateUnitId(state, payload) {
            return {
                ...state,
                orgUniqueId: payload
            }
        },
        clear() {
            return initialState
        },
        setUserTabName(state, payload) {
            return {
                ...state,
                userTabName: payload
            }
        },
        setDelUserModalOpen(state, payload) {
            return {
                ...state,
                isUserDelModalOpen: payload
            }
        },
        setDeactivateUserModal(state, payload) {
            return {
                ...state,
                isUserDeactivateModal: payload
            }
        },
        setDelUser(state, payload) {
            return {
                ...state,
                userToDel: payload
            }
        },
        setNewUserDetails(state, payload) {
            return {
                ...state,
                newUserDetails: payload
            }
        },
        setProfileImageUploadData(state, payload = {}) {
            return {
                ...state,
                imageProfileObjectCloudinary: payload
            }
        },
        loaderStatus(state, payload) {
            return {
                ...state,
                loaderBar: payload
            }
        },

        setSearchedUsersList(state, payload) {
            return {
                ...state,
                searchedUsers: payload
            }
        },
        setSearchQuery(state, payload) {
            return {
                ...state,
                searchUserQuery: payload
            }
        },
        setdeactUserData(state, payload) {
            return {
                ...state,
                deactUserData: payload
            }
        },
        setUsersWithPermissions(state, payload) {
            return {
                ...state,
                usersWithPermission: payload
            }
        },
        setUserTreeSelectedPath(state, payload) {
            return {
                ...state,
                userTreeSelectedPathValue: payload
            }
        },
    },
    effects: {
        updateState(user) {
            dispatch.users.storeUser(user);
        },

        async updateUser(payload) {
            payload.type = 'invite'
            try {
                await accountUsersService.patch(payload._id, payload);
                // toastr.success('Message', 'User updated successfully');
                if (payload.userid.toString() === payload._id.toString()) {
                    dispatch.app.modifyUserName(payload);
                }
            } catch (err) {
                throw err;
            }

        },
        storeUnitId(payload) {
            dispatch.users.updateUnitId(payload);
        },
        async deleteUserInTeam(payload) {
            try {
                await removeUserTeamsService.patch(payload.teamId, payload);
                toastr.success('Message', 'User Removed Successfully')
            } catch (err) {

                //toastr.error('Message', 'error while removing user')
                throw (err);
            }
        },
        setUsersListData(users) {
            dispatch.users.setUsersList(users);
        },

        userDelModalOpen(onOffState) {
            dispatch.users.setDelUserModalOpen(onOffState);
        },
        userDeactivateModal(onOffState) {
            dispatch.users.setDeactivateUserModal(onOffState);
            dispatch.users.setdeactUserData({});
        },

        async addUserToDelete(user) {
            // await dispatch.users.checkUserAssignedToInitiative(user._id)
            dispatch.users.setDelUser(user);
        },
        setProfileImage(payload) {
            dispatch.users.setProfileImageUploadData(payload);
        },
        setloaderStatus(payload) {
            dispatch.users.loaderStatus(payload);
        },


        async searchUsers(payload) {
            let searchQuery = {};

            if (payload.firstName) {
                payload.firstName = payload.firstName.replace(".", "\\.");
                searchQuery.firstName = {
                    $regex: payload.firstName,
                    $options: 'i'
                };
            }
            if (payload.lastName) {
                payload.lastName = payload.lastName.replace(".", "\\.");
                searchQuery.lastName = {
                    $regex: payload.lastName,
                    $options: 'i'
                };
            }
            if (payload.email) {
                payload.email = payload.email.replace(".", "\\.");
                searchQuery.email = {
                    $regex: payload.email,
                    $options: 'i'
                };
            }
            var organizations = {};
            var suborganizations = {};
            organizations["$elemMatch"] = {
                "id": payload.organizationId
            };

            if (payload.role) {
                organizations["$elemMatch"] = {
                    "role": payload.role,
                    "id": payload.organizationId
                };
            }
            searchQuery.organizations = organizations;
            if (payload.subOrgId) {
                suborganizations["$elemMatch"] = {
                    "id": payload.subOrgId
                };
                searchQuery.suborganizations = suborganizations;
            }
            let users = await accountUsersService.find({
                query: searchQuery
            });
            // dispatch.users.setUsersListData(users);
        },
        setSearchedUsers(payload) {
            dispatch.users.setSearchedUsersList(payload);
        },
        setSearchUserQuery(payload) {
            dispatch.users.setSearchQuery(payload);
        },
        async getdeactivateuserdetails(payload) {
            const suborgs = await subOrganizationService.find({
                query: {
                    'organizationId': payload.organisationId,
                    'members': {
                        $elemMatch: {
                            'accountUserId': payload.accountUserId
                        }
                    },
                    'active': true
                }
            })
            dispatch.users.setdeactUserData(suborgs);
        },
        storeDeactUserData(payload) {
            dispatch.users.setdeactUserData(payload);
        },

        async deactivateUserFromOrgAsync(payload) {
            try {
                payload.String = 'deactivateUserFromOrganization'
                await organizationService.patch(payload.organizationId, payload);
                // await removeUserFromOrgService.remove(payload.accountUserId, { query: {
                //     organizationId: payload.organizationId,
                //     accountId: payload.accountId
                // } });
                if (payload.orgUniqueId) {
                    dispatch.organizationTab.getUsersTreeAsync({ id: payload.orgUniqueId, accountId: payload.accountId });
                } else {
                    dispatch.organizationTab.getUsersTreeAsync({ id: payload.organizationId, accountId: payload.accountId });
                }
                toastr.success('Message', 'User Removed Successfully');
            }
            catch (err) {

                // toastr.error('Message', err.message)
                throw err;
            }
        },
        async replaceDeactivateUserFromOrgAsync(payload,state) {
            try {
                let updatedOrganization = state.app.selectedOrganisation;
                updatedOrganization.users = updatedOrganization.users.map(user => {
                    if (user.accountUserId.toString() === payload.userId.toString()) {
                        user.deletionInProgress = true;
                    }
                    return user;
                });
                if(updatedOrganization.id){
                    updatedOrganization._id = updatedOrganization.id;
                    payload.organizationId = updatedOrganization.id;
                }
                delete updatedOrganization.id;
                const updatedOrg = await organizationService.patch(payload.organizationId, {
                    $set: {
                        users: updatedOrganization.users
                    }
                });
                const userId = payload.userId;
                delete payload.userId;
                payload.deleteUser = true;
                const org = {...updatedOrg};
                org.id = org._id;
                org.role = updatedOrganization.role;
                await dispatch.app.setSelectedOrganisationData(org);
                await dispatch.organizationTab.getUsersTreeAsync({ id: state.app.selectedOrganisation.id, accountId: payload.accountId });
                deleteUserFromOrgService.patch(userId, payload,{ query: { organizationId: updatedOrg._id, accountId: payload.accountId } });
                await dispatch.organizationTab.getOrgnizationUnitAsync(updatedOrg._id);
                toastr.success('Removal in progress...', 'The user will be removed once the process is complete.');
            }
            catch (err) {

                // toastr.error('Message', err.message)
                throw err;
            }
        },
        async checkUserAssignedToInitiative(payload) {

            await initiativesService.find({
                query: {
                    'type': 'user',
                    $or: [{
                        'raci': {
                            'r': {
                                $elemMatch: {
                                    'accountUserId': payload
                                }
                            }
                        }
                    },
                    {
                        'raci': {
                            'c': {
                                $elemMatch: {
                                    'accountUserId': payload
                                }
                            }
                        }
                    },
                    {
                        'raci': {
                            'i': {
                                $elemMatch: {
                                    'accountUserId': payload
                                }
                            }
                        }
                    },
                    {
                        'raci': {
                            'a': {
                                'accountUserId': payload
                            }
                        }
                    },
                    ]

                }
            })

        },
        async getAccountUsersWithPermissions(payload) {
            if (payload && payload.searchParam) {
                let data = await usersPermissionsService.find({ query: { queryParam: payload.searchParam } });
                dispatch.users.setUsersWithPermissions(data);
            }
            else {
                let data = await usersPermissionsService.find();
                dispatch.users.setUsersWithPermissions(data);
            }

        },
        async updatePermissions(payload) {
            try {
                let data = await usersPermissionsService.patch(null, payload);
                dispatch.users.getAccountUsersWithPermissions();
            }
            catch (e) {
                throw e;
            }
        },
        async getUserById(userId, state) {
            if (state.users.managerList && state.users.managerList.length > 0) {
                for (let manager of state.users.managerList) {
                    if (manager._id.toString() === userId.toString()) {
                        dispatch.users.updateState(manager);
                        break;
                    }
                }
            }
            else {
                const users = await accountUsersService.get(userId);
                dispatch.users.updateState(users);
            }
        },
        userTreeSelectedPath(payload) {
            dispatch.users.setUserTreeSelectedPath(payload);
        },
    }
}